import { AGENT_SELECT_CUSTOMER } from "../actions/types";

const initialState = {
  agentEmailId: "",
  accountId: "",
  mtn: "",
  serviceType: "",
  effectiveDate: "",
  endDate: "",
  status: ""
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case AGENT_SELECT_CUSTOMER:
      return {
        ...state,
        ...payload
      };
    default:
      return state;
  }
};
